import React from 'react';
import Text from '../containers/Text';
import RouteLink from './RouteLink';
import ShopBenefits from './ShopBenefits';
import OpeningTimes from './OpeningTimes';
import Phone from './Phone';
import Address from './Address';
import DetailLinkContainer from '../containers/DetailLinkContainer';
import CallbackButtonContainer from '../containers/CallbackButtonContainer'
import HolidayAlert from '../components/HolidayAlert';


const QuickInfo = (props) => {
    const address = {
        street: props.street,
        houseNumber: props.houseNumber,
        zip: props.zip,
        city: props.city
      };

  return (
    <div className='quick-info'>
      <HolidayAlert shop={props} />

      <h3 className={`t-h3${props.isPaketFuxx ? ' paketfuxx' : ''}`}>{props.description || props.name}</h3>

      <p className="mb-0 t-md">{props.contactPerson || ''}</p>

      <Address className='t-md mb-1' {...address} inline={false} />

      <Phone phoneNumber={props.phone} isQuickInfo={true}/>
      <ShopBenefits hasBoxes={props.hasBoxes} acceptsSuitcases={props.acceptsSuitcases} />

      <CallbackButtonContainer shop={props} />

      {props.showRouteLink ? <RouteLink
        isDetailLinkOnList={false}
        isDetailLinkOnMap={true}
        end={address} /> : null}

      {props.showDetailLink ? <DetailLinkContainer
                                parcelShopNumber={props.parcelShopNumber}
                                isPaketParcelLock={props.isPaketParcelLock}
                                isDetailLinkOnMap={true}
                                isDetailLinkOnList={false}
                                shop={props}/> : null
      }

      <hr />
      <h4 className="t-h4 d-none d-md-block"><Text id='details.opening-hours'/></h4>
      <h4 className="t-h4 d-md-none"><Text id='details.opening-hours-today'/></h4>

      <OpeningTimes hours={props.hours} isPaketParcelLock={props.isPaketParcelLock}/>
    </div>
  );
};

// Container Component
// TODO: move this into container file
import {connect} from 'react-redux';

const mapStateToProps = ({config}, {sortCode1}) => ({
  showDetailLink: true,
  showRouteLink: !config.callbackUrl,
  showCallbackButton: !!config.callbackUrl && config.sortCode1 === sortCode1
});

export default connect(mapStateToProps)(QuickInfo);
